<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system/index';
	import EventLog from 'src/components/EventLog/EventLog.svelte';
	import type { Device } from 'src/types/Device.ts';

	let openedEventTimestamp = null;

	export let device: Device;
</script>

<SidepanelContent>
	<EventLog {device} type={'device'} {openedEventTimestamp} />
</SidepanelContent>
